/**
 * Boombox route catalog — string-literal const enum used to type-
 * check `agent-config.tsx`'s page hrefs at compile time. If a path
 * isn't here, you can't put it in the agent JUMP TO list.
 *
 * Single source of truth for top-level navigation surfaces. Detail
 * pages (e.g. `/contacts/:id`) aren't listed because they're
 * parameterised — jump-to is for top-level entry points.
 */

export const BOOMBOX_ROUTES = {
  HOME: '/',
  PEOPLE: '/contacts',
  LISTS: '/lists',
  TEMPLATES: '/templates',
  LAYOUTS: '/layouts',
  SEND: '/send',
  MESSAGES: '/communications',
  SCHEDULE: '/schedule',
  ADMIN_AI: '/admin/ai',
  ADMIN_INTEGRATIONS: '/admin/integrations',
  ADMIN_SENDERS: '/admin/senders',
  ADMIN_IMPORTS: '/admin/imports',
  ADMIN_INBOUND: '/inbound',
  ADMIN_TOPICS: '/admin/topics',
  ADMIN_AUDITS: '/admin/audits',
  ADMIN_TEAM: '/admin/team',
  /**
   * Preview-only. The backing `/api/captured-comms` endpoint is mounted
   * only when `ENVIRONMENT=preview` (see boombox `server/src/routes/api.ts`),
   * so this page renders an empty list on non-preview deployments.
   */
  ADMIN_CAPTURED_COMMS: '/admin/captured-comms',
} as const

export type BoomboxRoute = (typeof BOOMBOX_ROUTES)[keyof typeof BOOMBOX_ROUTES]
